import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PageHead from '../PageHead';

const NavLink = ({ name, isActive, onClick }) => {
  const navLinkClasses = classNames(
    `flex flex-col items-center py-4 px-6 text-sm font-bold text-center rounded-t-lg border-t border-l border-r lg:px-8 grow lg:grow-0`,
    isActive ? 'border-grey-2 drop-shadow-sm' : 'border-grey-2 text-blue-5 bg-slate-1 border-b hover:text-purple-6'
  );
  return (
    <button onClick={onClick} className={navLinkClasses}>
      {name}
    </button>
  );
};

NavLink.propTypes = {
  name: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const SessionsPageContentHeadNav = ({ activeCategory, onCategoryChange }) => {
  const handleClick = (category) => (e) => {
    e.preventDefault();
    onCategoryChange(category);
  };

  return (
    <PageHead title="Sessions" wrap>
      <div className="flex">
        <NavLink name="Upcoming" isActive={activeCategory === 'upcoming'} onClick={handleClick('upcoming')} />
        <NavLink name="Completed" isActive={activeCategory === 'completed'} onClick={handleClick('completed')} />
        <NavLink name="Cancelled" isActive={activeCategory === 'cancelled'} onClick={handleClick('cancelled')} />
      </div>
    </PageHead>
  );
};

SessionsPageContentHeadNav.propTypes = {
  activeCategory: PropTypes.oneOf(['upcoming', 'completed', 'cancelled']).isRequired,
  onCategoryChange: PropTypes.func.isRequired,
};

export default SessionsPageContentHeadNav;
